import { WidgetNames } from '@finxone-platform/shared/sys-config-types';
import { LayoutPositionUpdates } from '../services/account-service/account.type';

export class UpdateGridLayout {
  static readonly type = '[GridLayout] UpdateGridLayout';
  constructor(public layoutPositionUpdates: LayoutPositionUpdates) {}
}

export class WidgetClicked {
  static readonly type = '[GridLayout] WidgetClicked';
  constructor(public name: string, public uniqueId: string) {}
}

export class SelectWidget {
  static readonly type = '[GridLayout] SelectWidget';

  constructor(public uniqueId: string, public multiSelect: boolean, public widgetType?: WidgetNames) {}
}

export class RenameLayoutContainerName {
  static readonly type = '[GridLayout] RenameLayoutContainerName';
  constructor(public renamedContainerName: string, public uniqueId: string) {}
}
